module.exports = __webpack_public_path__ + "assets/wa-icon.d3500a09.svg";